import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MainService } from 'src/app/services/main.service';

@Component({
  selector: 'app-privace-polilcy',
  templateUrl: './privace-polilcy.component.html',
  styleUrls: ['./privace-polilcy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {
  language = JSON.parse(localStorage.getItem('language'))

  constructor(private mainService: MainService, private sanitizer: DomSanitizer,
    private loader: NgxUiLoaderService) { }
  flag: any
  privacy_content: SafeHtml;

  ngOnInit() {
    this.flag = localStorage.getItem('language_flag');
    this.loader.start();
    this.mainService.getPrivacyPolicy().subscribe(response => {
      if (this.flag === 'th') {
        this.privacy_content = this.sanitizer.bypassSecurityTrustHtml(response['Result']['Th']);
      } else {
        this.privacy_content = this.sanitizer.bypassSecurityTrustHtml(response['Result']['En']);
      }
      this.loader.stop();
    });
  }
}
